import { StarMark } from "../ui/StarMark";
import "./BrandStatement.css";

/** Manifest breu que separa la capçalera visual del concurs. */
export function BrandStatement() {
	return (
		<section className="brand-statement" aria-labelledby="brand-statement-title">
			<div className="brand-statement__copy">
				<h2 id="brand-statement-title">
					Un mar de cultures
					<br />
					entre terres
				</h2>
				<p>on el llibre és la brúixola i Cadaqués, el port d’inspiració.</p>
			</div>

			<div className="brand-statement__mark" aria-label="Cosa Nova 17488">
				<StarMark />
				<span>
					COSA
					<br />
					NOVA
					<br />
					17488
				</span>
			</div>
		</section>
	);
}
